import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="py-8 px-6 border-t border-border">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
        <p>© {new Date().getFullYear()} Local Route. All rights reserved.</p>
        <div className="flex gap-6">
          <Link 
            to="/portfolio/local-route/privacy" 
            className="hover:text-foreground transition-colors"
          >
            Privacy Policy
          </Link>
          <Link 
            to="/" 
            className="hover:text-foreground transition-colors"
          >
            Back to cemates.me
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
